import VisibilityIcon from '@mui/icons-material/Visibility';
import { CircularProgress, IconButton } from '@mui/material';
import { useTranslation } from 'next-i18next';
import React, { useEffect, useState } from 'react';
import { MessagingAttendee } from '../../../../../../interfaces/interfaces';
import { useSelector } from '../../../../../../reduxToolkit/typedRedux';
import { getVcardMessageDetails } from '../../../../../../services/services';
import VyTooltip from '../../../../../common/VyTooltip';
import { Vcard } from './Vcard';

interface MessagingVcardProps {
  attendee: MessagingAttendee;
  message?: string;
  isOwn?: boolean; // This is correct now - must be fixed in messaging center
  instantLoadDetails?: boolean;
}

export const MessagingVcard = (props: MessagingVcardProps) => {
  const { attendee, message, isOwn, instantLoadDetails } = props;

  const registrationFields = useSelector(({ common }) => common.registrationFields);
  const user = useSelector(({ common }) => common.user);

  const { t } = useTranslation();

  const [attendeeDetails, setAttendeeDetails] = useState<{ [key: string]: { value: string; type?: string } } | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (instantLoadDetails && !attendeeDetails) extractAttendeeDetails();
  }, [message]);

  async function extractAttendeeDetails() {
    if (!message) return;
    setIsLoading(true);
    try {
      const res = await getVcardMessageDetails(message);
      let details: { [key: string]: { value: string; type?: string } } = {
        name: { value: res.user.name },
        email: { value: res.user.email },
      };
      res.registrationFields.map((field) => {
        const eventField = registrationFields.find(
          (f) =>
            f._id === field.field &&
            !f.isHidden &&
            f.fieldType !== 'file' &&
            f.fieldType !== 'multi-files' &&
            f.fieldType !== 'checkbox' &&
            f.isIncludedInContactshare
        );
        if (eventField && field.value) details = { ...details, [eventField.label]: { value: field.value, type: eventField.fieldType } };
      });
      setIsLoading(false);
      setAttendeeDetails(details);
    } catch (err) {
      setIsLoading(false);
    }
  }

  if (!attendee || !message) return null;

  const username = isOwn ? user?.name : attendee.name;

  if (!attendeeDetails)
    return (
      <div className="flex justify-between items-center w-72 p-2 border rounded-xl mt-2">
        <span className="font-bold">
          {' '}
          {isOwn ? t('event:messaging.reveal-own-vcard-description') : t('event:messaging.reveal-vcard-description', { username: username })}
        </span>
        <IconButton disabled={isLoading} onClick={extractAttendeeDetails} size="large">
          {isLoading ? (
            <CircularProgress />
          ) : (
            <VyTooltip title={t('event:messaging.reveal-vcard-tooltip')}>
              <VisibilityIcon />
            </VyTooltip>
          )}
        </IconButton>
      </div>
    );
  return <Vcard attendee={attendee} attendeeDetails={attendeeDetails} isOwn={isOwn} />;
};
